import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-100" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — EL SISTEMA',
    subtitle: 'La base que hace funcionar todo',
    desc: 'Método completo de batch cooking, sesión de las 3 horas, organización del freezer, rotulado, tiempos de conservación y planilla maestra de stock.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-101" />,
    color: 'bg-emerald-500/10 border-emerald-500/20',
    title: 'TOMO 2 — INVIERNO BLINDADO',
    subtitle: 'Mayo a Agosto sin improvisación',
    desc: '28 recetas de guisos, cazuelas, sopas y estofados. Los platos que el cuerpo pide cuando hace frío. Listos para calentar en 10 minutos.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-400" data-id="element-102" />,
    color: 'bg-amber-500/10 border-amber-500/20',
    title: 'TOMO 3 — EXPRESS VERANO',
    subtitle: 'Enero a Marzo sin encender el horno',
    desc: '32 recetas frescas y livianas. Milanesas, tartas frías, wraps, ensaladas base y helados caseros. Todo resuelto para el calor.'
  }, {
    icon: <Library className="w-8 h-8 text-rose-400" data-id="element-103" />,
    color: 'bg-rose-500/10 border-rose-500/20',
    title: 'TOMO 4 — KIDS & SALUDABLE',
    subtitle: 'Luncheras y meriendas de toda la semana',
    desc: '25 recetas para chicos. Nuggets caseros, galletitas sin conservantes, sistema de luncheras para 4 semanas completas.'
  }, {
    icon: <Notebook className="w-8 h-8 text-purple-400" data-id="element-104" />,
    color: 'bg-purple-500/10 border-purple-500/20',
    title: 'TOMO 5 — PROTEÍNAS MAESTRAS',
    subtitle: 'El manual de abasto definitivo',
    desc: '17 recetas y la Matriz de Combinaciones: 6 proteínas base × 5 salsas = 30 cenas distintas. Cómo comprar carne un 40% más barato.'
  }, {
    icon: <BookType className="w-8 h-8 text-orange-400" data-id="element-105" />,
    color: 'bg-orange-500/10 border-orange-500/20',
    title: 'TOMO 6 — PANIFICADOS & DULCES',
    subtitle: 'El freezer más dulce del sistema',
    desc: '35+ recetas de panes caseros, medialunas, bizcochuelos, galletitas por docenas y postres. El desayuno, la merienda y el postre del año.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-106">
      <div className="max-w-5xl mx-auto" data-id="element-107">
        <div className="text-center mb-10" data-id="element-108">
          <Badge variant="success" className="mb-4" data-id="element-109">
            🏆 PUNTO DIGITAL™ — MEGAPACK FREEZER LLENO
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-110">
            6 Tomos + 6 Bonos — Todo el año resuelto
          </h2>
          <p className="text-xl text-slate-400" data-id="element-111">
            300+ páginas — 150+ recetas — Sistema completo
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-112">
            <span data-id="element-113">Sistema</span> <span className="text-slate-600" data-id="element-114">→</span>
            <span data-id="element-115">Invierno</span> <span className="text-slate-600" data-id="element-116">→</span>
            <span data-id="element-117">Verano</span> <span className="text-slate-600" data-id="element-118">→</span>
            <span data-id="element-119">Kids</span> <span className="text-slate-600" data-id="element-120">→</span>
            <span data-id="element-121">Proteínas</span> <span className="text-slate-600" data-id="element-122">→</span>
            <span data-id="element-123">Dulces</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-124">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-125">
            <span className="text-3xl" data-id="element-126">🧊</span> 6 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-127">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-128">
                <div className="flex items-start gap-4" data-id="element-129">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-130">
                    {tomo.icon}
                  </div>
                  <div data-id="element-131">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-132">
                      {tomo.title}
                    </h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-133">
                      {tomo.subtitle}
                    </p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-134">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-135">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-136">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-137">
            {['Recetas completas con paso a paso detallado', 'Tablas de tiempos de conservación', 'Tips de congelado y regeneración', 'Sistema de porciones por tipo de hogar', 'Costos estimados en pesos argentinos', 'Variantes económicas de cada preparación', 'Planilla de uso semanal lista para imprimir', '100% pensado para la realidad argentina'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-138">
                <CheckCircle className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-139" />
                <span className="text-slate-300" data-id="element-140">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: "Mapa Anti 'No Sé Qué Sacar del Freezer'",
    desc: 'El sistema VEC para decidir qué cenar en 2 minutos con lo que ya tenés congelado.',
    value: '$8.000'
  }, {
    title: 'Lista Maestra de Compras Inteligentes',
    desc: 'Listas semanales, quincenales y mensuales listas para usar. Nunca más ir al súper sin saber qué comprar.',
    value: '$8.000'
  }, {
    title: '52 Ideas de Cenas Resueltas en 10 Minutos',
    desc: 'Una idea lista para cada semana del año. Organizadas por nivel de energía y tiempo disponible.',
    value: '$9.000'
  }, {
    title: 'Checklist de Reabastecimiento del Freezer',
    desc: 'El sistema semáforo para que el freezer nunca se vacíe sin que te des cuenta.',
    value: '$8.000'
  }, {
    title: 'Menús Puente para Días de Caos',
    desc: '25 menús para los días donde todo sale mal y el delivery parece la única salida. Spoiler: no lo es.',
    value: '$9.000'
  }, {
    title: 'Kit de Etiquetas y Rotulado Pro',
    desc: 'Sistema visual completo con etiquetas listas para imprimir. Encontrá lo que buscás en 10 segundos.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-141">
      <div className="max-w-5xl mx-auto" data-id="element-142">
        <div className="text-center mb-8" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-144">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-145" />6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-146">
            Siempre incluidos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8" data-id="element-147">
          {bonuses.map((bono, i) => <Card key={i} className="relative overflow-hidden group hover:border-brand-500/50 transition-colors" data-id="element-148">
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-149">
                BONO {i + 1}
              </div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-150">
                {bono.title}
              </h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-151">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-152">
                <span className="line-through text-slate-500 text-sm" data-id="element-153">
                  Valor {bono.value}
                </span>
                <span className="text-emerald-400 font-bold" data-id="element-154">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-gradient-to-r from-brand-900/50 to-emerald-900/50 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-155">
          <p className="text-slate-300 mb-2" data-id="element-156">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-157">
            $51.000
          </p>
          <p className="text-2xl font-bold text-emerald-400" data-id="element-158">
            → GRATIS con tu Megapack
          </p>
        </div>
      </div>
    </section>;
}